<template>
<div class="vx-card px-6 py-2">
    <div class="vx-row">
        <div class="vx-col"></div>
    </div>
    <ag-grid-vue style="height: 55vh" ref="agGridTable" :gridOptions="gridOptions"
                 class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                 :defaultColDef="defaultColDef"
                 :rowData="testResultsData" :animateRows="true" :pagination="true"
                 :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                 :onGridReady="onGridReady" :suppressPaginationPanel="true">
    </ag-grid-vue>

    <div class="vx-row" v-if="testResultsData.length > 0">
        <div class="vx-col md:w-1/2">
            <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                <span class="vx-col mt-2">Số phần tử / trang:</span>
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                    <div
                        class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                            <span class="mr-2">
                                {{
                                    testResultsData.length - currentPage * pageSize > 0 ? currentPage *
                                        pageSize
                                        : testResultsData.length
                                }} /
                                {{ totalElements }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                    </div>
                    <vs-dropdown-menu>
                        <vs-dropdown-item @click="changePageSize(20)">
                            <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="changePageSize(30)">
                            <span>30</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="changePageSize(50)">
                            <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="changePageSize(100)">
                            <span>100</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>
        </div>
        <div class="vx-col md:w-1/2 w-full">
            <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage"/>
        </div>
    </div>
</div>
</template>

<script>

import vSelect from 'vue-select';
import DateRangePicker from '../../../../../../components/vue2-daterange-picker/components/DateRangePicker.vue';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import moment from "moment";
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';
import CellRendererActionsTestResults from './cell-renderer/CellRendererActionsTestResults'

ModuleRegistry.registerModules([ClientSideRowModelModule]);

export default {
    name: "TestResults",
    components: {
        vSelect,
        DateRangePicker,
        AgGridVue,
        CellRendererActionsTestResults,
    },
    props: {
        loyaltyCustomerId: {
            default: null,
            type: Number,
        },
    },
    data() {
        return {
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {
                resizable: true,
            },
            columnDefs: [
                {
                    headerName: this.$t('menuCustomer.stt'),
                    field: 'stt',
                    width: 80,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Ngày thực hiện',
                    field: 'examinationDateStr',
                    minWidth: 150,
                },
                {
                    headerName: 'Mã phiếu xét nghiệm',
                    field: 'nanoExaminationTestCode',
                    minWidth: 280,
                },
                {
                    headerName: 'Hành động',
                    field: 'actions',
                    minWidth: 120,
                    cellRendererFramework: 'CellRendererActionsTestResults',
                    suppressSizeToFit: true,
                    pinned: 'right'
                },
            ],
            pageNumber: 0,
            pageSize: 20,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
            dateRange: {
                // endDate: new Date(new Date().setHours(23, 59, 59, 999)),
                // startDate: new Date(new Date().setDate(new Date().getDate() - 7)).setHours(0,0,0,0),
                endDate: null,
                startDate: null,
            },
            testResultsData: [],
        }
    },

    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
    },

    created() {
        this.getTestResults();
    },

    methods: {
        getTestResults() {
            let payload = {
                loyaltyCustomerId: this.loyaltyCustomerId,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                startDate: this.dateRange.startDate,
                endDate: this.dateRange.endDate,
            }

            this.$vs.loading();
            this.$crm.post('/beauty-examination-test/find-by-condition', payload).then(res => {
                if (res.data.content && res.data.content.length > 0) {
                    this.testResultsData = res.data.content.map(el => {
                        el.stt = this.pageNumber * this.pageSize + res.data.content.indexOf(el) + 1;
                        el.examinationDateStr = el.examinationDate ? moment(el.examinationDate).format('DD/MM/YYYY HH:mm') : null;
                        return el;
                    })
                }
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getTestResults();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getTestResults();
        },
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style scoped>

</style>
